import React, { useEffect, useState } from "react";
import { HiChevronDown } from "react-icons/hi";
import dataEn from "../../../languages/en/faqData.json"; // Import the FAQ data from the JSON file
import dataTh from "../../../languages/th/faqData.json"; // Import the FAQ data from the JSON file
const EighthSection = ({ language }) => {
  const data = language === "en" ? dataEn : dataTh;
  const [faqs, setFaqs] = useState(data.faqs); // Use the "faqs" array from the imported data

  const toggleFAQ = (index) => {
    setFaqs((prevFaqs) =>
      prevFaqs.map((faq, i) => {
        if (i === index) {
          return { ...faq, isOpen: !faq.isOpen };
        }
        return faq;
      })
    );
  };

  useEffect(() => {
    setFaqs(data.faqs);
  }, [language]);

  return (
    <section className="py-10 w-3/4 mx-auto">
      <div className="max-w-3xl mx-auto">
        <h2 className="text-4xl font-bold text-center mb-16">{data.title}</h2>
        <hr className="border-gray-300 mb-2" />
        <div>
          {faqs.map((faq, index) => (
            <div key={index}>
              <div
                className="flex items-center justify-between cursor-pointer my-8"
                onClick={() => toggleFAQ(index)}
              >
                <h3 className="text-neutral font-prompt font-medium text-lg">
                  {faq.question}
                </h3>
                <HiChevronDown
                  className={`transition-transform transform ${
                    faq.isOpen ? "rotate-180" : "rotate-0"
                  }`}
                />
              </div>
              {faq.isOpen && (
                <p className="text-neutral font-prompt text-gray-600 mb-8">
                  {faq.answer}
                </p>
              )}

              <hr className="border-gray-300 mb-2" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default EighthSection;
